import {makeStyles} from "@material-ui/core/styles";

const StyleResultList = makeStyles(theme => ({
    button: {
        '&$selected, &$selected:hover, &:hover': {
            backgroundColor: "transparent"
        }
    },
    card: {
        display: "flex", flexDirection: "column", padding: 10
    }
}));

export default StyleResultList;